// removed by extract-text-webpack-plugin
module.exports = {"actionsNav":"ActionsNav__actionsNav___1fiTq","inModal":"ActionsNav__inModal___3kAUt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/molecules/ActionsNav/ActionsNav.scss
// module id = 619
// module chunks = 0